<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="选择商品" name="first">
            <el-form :model="goodsForm" :rules="rules" ref="goodsForm" label-width="190px" size="small" class="demo-ruleForm">
              <el-form-item label="选择商品：" prop="goodsId">
                <el-select style="width: 424px;" v-model="goodsForm.goodsId" placeholder="请选择商品">
                  <el-option v-for="(item,index) in goodsList" :label="item.goodsName" :value="item.goodsId"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="medium" @click="nextBtn('second')">下一步</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="基础信息" name="second">
            <el-form :model="goodsForm" :rules="rules" ref="goodsForm" label-width="190px" size="small" class="demo-ruleForm">
              <el-form-item label="商品名称：" prop="goodsName">
                <el-input style="width: 424px;" v-model="goodsForm.goodsName" placeholder="请输入商品名称"></el-input>
              </el-form-item>
             <el-form-item label="图片：" prop="thumb">
                <el-upload
                  :action="baseUrl+'/system/common/upload/uploadFile'"
                  list-type="picture-card"
                  :headers="{'Authorization': token}"
                  :multiple="false"
                  :limit="1"
                  :file-list="fileList"
                  :on-remove="delImgBtn.bind(null,{'type':1})"
                  :on-success="uploadImgBtn">
                  <i class="el-icon-plus"></i>
                  <div slot="tip" class="el-upload__tip">建议尺寸：800*800px，最多一张，若需要更换图片，请先删除原图片</div>
                </el-upload>
              </el-form-item>
              <el-form-item label="商品相册：" prop="pictureList">
                <el-upload
                  :action="baseUrl+'/system/common/upload/uploadFile'"
                  list-type="picture-card"
                  :headers="{'Authorization': token}"
                  :multiple="false"
                  :limit="5"
                  :file-list="pictureListTwo"
                  :on-remove="delImgBtn.bind(null,{'type':2})"
                  :on-success="uploadTwoBtn">
                  <i class="el-icon-plus"></i>
                  <div slot="tip" class="el-upload__tip">建议尺寸：800*800px，最多9张，若需要更换图片，请先删除原图片</div>
                </el-upload>
              </el-form-item>
              <el-form-item label="规格：" prop="integralGoodsSpecSaveDtoList">
                <el-table
                  :data="goodsForm.integralGoodsSpecSaveDtoList"
                  border
                  style="width: 100%">
                  <el-table-column
                    prop="specName"
                    label="规格">
                  </el-table-column>
                  <el-table-column
                    prop="thumb"
                    label="图片">
                    <template slot-scope="scope">
                      <el-image
                        style="width: 32px;"
                        :src="scope.row.thumb"
                        :preview-src-list="[scope.row.thumb]"
                        fit="contain"></el-image>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="specPrice"
                    label="售价">
                  </el-table-column>
                  <el-table-column
                    prop="exchangeIntegral"
                    label="兑换积分"
                    width="120">
                    <template slot-scope="scope">
                      <el-input style="width: 90px;" v-model="scope.row.exchangeIntegral" placeholder="请输入"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="stockNum"
                    label="库存">
                  </el-table-column>
                </el-table>
              </el-form-item>
              <el-form-item label="排序：" prop="sort">
                <el-input style="width: 424px;" v-model="goodsForm.sort" placeholder="请输入排序（默认 1 ）"></el-input>
              </el-form-item>
              <el-form-item label="是否开启：" prop="status">
                <el-switch
                  v-model="goodsForm.status"
                  active-color="#1890FF"
                  inactive-color="#CCCCCC">
                </el-switch>
              </el-form-item>
              <el-form-item>
                <el-button size="medium" @click="preBtn('first')">上一步</el-button>
                <el-button type="primary" size="medium" @click="nextBtn('third')">下一步</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="商品详情" name="third">
            <el-form :model="goodsForm" :rules="rules" ref="goodsForm" label-width="40px" size="small" class="demo-ruleForm">
              <el-form-item>
                <editor :height="690" v-model="goodsForm.goodsDetail"></editor>
              </el-form-item>
              <el-form-item>
                <el-button size="medium" @click="preBtn('second')">上一步</el-button>
                <el-button type="primary" size="medium" @click="saveBtn">保存</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-card>
  </div>
</template>

<script>
import { queryAllEnableGoodsList, fetchIntegralGoodsDetailById, saveIntegralGoods, updateIntegralGoods } from '@/api/integral'
import Editor from '@/components/Editor.vue'
export default {
  name: 'MallGoodsAdd',
  components: {
    Editor
  },
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      token:this.$token,
      fullscreenLoading: false,
      dataId: this.$route.query.dataId,
      activeName: 'first',
      activeNum:0,
      goodsList:[],
      fileList: [],
      /* 商品相册 */
      pictureListTwo: [],
      pictureList:[],
      goodsForm: {
        goodsId:'',
        goodsName:'',
        thumb: '',
        goodsDetail: '',
        sort: '',
        status: false,
        pictureList:[],
        integralGoodsSpecSaveDtoList:[]
      },
      rules: {
        goodsId: [
          { required: true, message: '请选择商品', trigger: 'blur' }
        ],
        goodsName: [
          { required: true, message: '请输入商品名称', trigger: 'blur' }
        ],
        thumb: [
          { required: true, message: '请上传图片', trigger: 'blur' }
        ],
        pictureList: [
          { required: true, message: '请上传相册', trigger: 'blur' }
        ],
        integralGoodsSpecSaveDtoList: [
          { required: true, message: '请完成规格', trigger: 'blur' }
        ]
      },
      isOne:1
    }
  },
  watch: {
    'goodsForm.goodsId': {
      handler(newVal, oldVal) {
        var that = this;
        if(that.dataId == '' || (that.dataId != '' && that.isOne == 2)){
          that.goodsList.forEach(function(item){
            if(newVal == item.goodsId){
              that.goodsForm.integralGoodsSpecSaveDtoList = item.integralGoodsSpecPageVoList;
            }
          });
        }
        that.isOne = 2;
      }
    }
  },
  mounted () {
    let token = sessionStorage.getItem('token')
    if (!token) {
      token = ''
    }
    this.token = token;
    this.goodsListFun();
    if(this.dataId != ''){
      // 编辑信息
      this.detailInfoFun();
    }
  },
  methods: {
    // 查询所有上架的商品列表
    goodsListFun(){
      var that = this;
      queryAllEnableGoodsList({}).then((res) => {
          if (res.errorCode === '0000') {
            var data = res.data;
            that.goodsList = data;
          }
        })
    },
    /* 商品详情数据 */
    detailInfoFun(){
      var that = this;
      fetchIntegralGoodsDetailById({id:that.dataId}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data;
          data.status =  data.status == 1 ? true : false;
          // 商品主图
          that.fileList.push({url: data.thumb});
          // 商品相册
          data.pictureList.forEach(function(item){
            that.pictureListTwo.push({url: item});
            that.pictureList.push(item);
          });
          data.integralGoodsSpecSaveDtoList = data.integralGoodsSpecPageVoList;
          that.goodsForm = data;
        }
        if (res.errorCode === '1001') {
          that.$message.error(res.msg);
        }
      });
    },
    /* 切换选项卡操作 */
    handleClick (tab) {},
    // 商品主图上传
    uploadImgBtn (file) {
      this.goodsForm.thumb = file.data.fileUrl
    },
    /* 删除上传的图片 */
    delImgBtn(obj,file,fileList){
      var type = obj.type;
      var that = this;
      switch (type) {
        case 1:
          // 商品主图
          var thumb = '';
          fileList.forEach(function(item){
            thumb = item.url;
          });
          that.goodsForm.thumb = thumb;
          break;
        case 2:
          // 商品相册
          var pictureList = [];
          fileList.forEach(function(item){
            pictureList.push(item.url);
          });
          that.pictureList = pictureList;
          break;
      }
    },
    /* 商品相册上传 */
    uploadTwoBtn (file) {
      this.pictureList.push(file.data.fileUrl)
    },
    /* 下一步操作 */
    nextBtn(name){
      this.activeName = name;
    },
    /* 上一步操作 */
    preBtn(name){
      this.activeName = name;
    },
    // 保存操作
    saveBtn(){
      var that = this;
      var dataId = that.dataId;
      var goodsForm = that.goodsForm;
      let status = goodsForm.status ? 1 : 0
      let sort = goodsForm.sort === '' ? 1 : goodsForm.sort
      let passData = {
        goodsId: goodsForm.goodsId,
        goodsName:goodsForm.goodsName,
        thumb:goodsForm.thumb,
        goodsDetail:goodsForm.goodsDetail,
        status:status,
        sort:sort,
        pictureList:that.pictureList,
        integralGoodsSpecSaveDtoList:goodsForm.integralGoodsSpecSaveDtoList
      }
      if(dataId != ''){
        passData.id = dataId;
        updateIntegralGoods(passData).then((res) => {
          that.backDataFun(res);
        })
      }else{
        saveIntegralGoods(passData).then((res) => {
          that.backDataFun(res);
        })
      }
    },
    backDataFun(res){
      var that = this
      if (res.errorCode === '0000') {
        this.$message({
          message: res.msg,
          type: 'success',
          onClose () {
            that.$router.go(-1)
          }
        })
      }
      if (res.errorCode === '1001') {
        this.$message.error(res.msg)
      }
    },
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/integralMall/MallGoodsAdd.vue